/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_1_TitleInputs */

const et_case_1_title = /** @type {(inputs: Case_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3,3x liikluse kasv 4 kuuga – nüüd 70% liiklusest SEO kaudu`)
};

const en_case_1_title = /** @type {(inputs: Case_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3.3x traffic growth in 4 months - now 70% of traffic from SEO`)
};

/**
* | output |
* | --- |
* | "3.3x traffic growth in 4 months - now 70% of traffic from SEO" |
*
* @param {Case_1_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const case_1_title = /** @type {((inputs?: Case_1_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_1_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_case_1_title(inputs)
	return en_case_1_title(inputs)
});